const { MESSAGE_TYPE_IMPORTANT, MESSAGE_TYPE_WARNING, MESSAGE_TYPE_SUCCESS  } = require("commonsComponents/OKMessage");

export const PAYEE_MESSAGE_BOX_STYLE = {
    WARN: 'WARN',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS'
}

export const PAYEE_VERIFICATION_STYLE = {
    [PAYEE_MESSAGE_BOX_STYLE.WARN]: MESSAGE_TYPE_IMPORTANT,
    [PAYEE_MESSAGE_BOX_STYLE.ERROR]: MESSAGE_TYPE_WARNING,
    [PAYEE_MESSAGE_BOX_STYLE.SUCCESS]: MESSAGE_TYPE_SUCCESS,
}

export const DEFAUTL_PAYEE_VERIFICATION_PARTY_NAME_MATCH = 'NO_RESPONSE'
export const DEFAUTL_PAYEE_VERIFICATION_MESSAGE_BOX_STYLE = PAYEE_MESSAGE_BOX_STYLE.ERROR
